import React from "react";
import "./Spinner.scss";

const Spinner = () => {
  return (
    <div className="spinner-wrapper">
      <div className="spinner">
        <div className="cube1"></div>
        <div className="cube2"></div>
      </div>
    </div>
  );
};

export default Spinner;
